module.exports = __webpack_public_path__ + "static/media/question.a2ac4469.mp3";